interface OptionProps {
  label: string;
  value: string;
  image?: any;
  icon?: any;
}

const getQuestionOrder = (questions: { [x: string]: { order: any } }) => {
  const questionOrder: any[] = [];
  Object.keys(questions).forEach((key) => {
    questionOrder[questions[key].order] = key;
  });

  return questionOrder.filter((value) => value);
};

const initQuestionsVisibility = (questions: any, questionOrder: any[]) => {
  const firstQuestion = questionOrder[0];
  const questionsVisibility: any = {};
  Object.keys(questions).forEach((name) => {
    questionsVisibility[name] = name === firstQuestion;
  });

  return questionsVisibility;
};

const transformLabel = (label: string, questionCode: string) => {
  let updatedLabel = '';
  switch (questionCode) {
    default:
      updatedLabel = label;
      break;
  }
  return updatedLabel;
};

const transformChoice = (
  choice: any,
  questionCode: string,
  t: any,
  annotations: any = []
) => {
  const choiceConfig: OptionProps = {
    value: choice.value ? choice.value : choice.label.toLowerCase(),
    label: transformLabel(choice.label, questionCode),
  };

  if (annotations['rf/popular-choice-img-srcset-template']) {
    choiceConfig.image = {
      src: annotations['rf/popular-choice-img-srcset-template'].replace(
        /__value__/g,
        encodeURI(choiceConfig.value)
      ),
      alt: `${choiceConfig.label} logo`,
    };
  }

  return choiceConfig;
};

const addSingleChoices = (
  singlechoice: { choices: any[] },
  annotations: any[],
  questionCode: string,
  t: any
) => {
  const TypeSingleChoices: any[] = [];
  singlechoice?.choices?.forEach((choice: any) => {
    TypeSingleChoices.push(
      transformChoice(choice, questionCode, t, annotations)
    );
  });
  return TypeSingleChoices;
};

const addJumpToOption = (question: any) => {
  const { annotations } = question;
  const jumpToOption = {
    value: `jumpTo_${annotations['rf/last-choice-jump-to']}`,
    jumpTo: annotations['rf/last-choice-jump-to'],
    label: 'questions.choices.change_my_car',
  };
  const exists = question?.singlechoice?.choices?.findIndex(
    (option: { value: string }) => option.value === jumpToOption.value
  );

  if (exists < 0) {
    question?.singlechoice?.choices.push(jumpToOption);
  }
  return question;
};
const transformquestions = (questions: any, t: any) => {
  const questionData: any = {};
  Object.entries(questions).forEach(([key, question]: [string, any]) => {
    const { annotations } = question;

    if (annotations['rf/buttons-per-row']) {
      question.annotations = {
        ...annotations,
        numberOfRows: `grid-cols-${annotations['rf/buttons-per-row']}`,
        buttonsPerRow: annotations['rf/buttons-per-row'],
      };
    }

    if (
      question.type === 'singlechoice' &&
      question.singlechoice?.popularcount
    ) {
      question.options = addSingleChoices(
        question.singlechoice,
        question.annotations,
        key,
        t
      ).slice(0, question.singlechoice.popularcount);
    }
    if (
      question.singlechoice?.popularcount === 0 &&
      question.annotations['rf/buttons-per-row'] > 1
    ) {
      question.options = addSingleChoices(
        question.singlechoice,
        question.annotations,
        key,
        t
      );
      question.type = 'radio';
    }
    question.placeholder = `questions.placeholders.${key}`;
    question.title = `questions.title.${key}`;
    if (question.singlechoice && question.singlechoice.choices) {
      question.singlechoice.choices = addSingleChoices(
        question.singlechoice,
        question.annotations,
        key,
        t
      );
    }

    if (question?.annotations['rf/last-choice-jump-to']) {
      question = addJumpToOption(question);
    }
    questionData[key] = question;
  });
  return questionData;
};

export default (flow: any, t?: any, updateQVisibility?: any) => {
  if (!flow) {
    return null;
  }
  const { questions } = flow;
  const questionOrder = getQuestionOrder(questions);
  const questionsVisibility = updateQVisibility
    ? { ...updateQVisibility }
    : initQuestionsVisibility(questions, questionOrder);
  const config = {
    questionOrder,
    questionsVisibility,
    questions: transformquestions(questions, t),
  };
  return config;
};
